/**
* @file 营销管理-广告管理
* */
<template>
  <div id="bannerFrame">
    <tab-frame :tabs="tabs"></tab-frame>
  </div>
</template>

<script>
export default {
  name: "bannerFrame",
  data() {
    return {
      // tabs列表
      tabs: [
        { label: '顶部广告', name: '/advertising' },
        { label: '专题广告', name: '/topic' },
        { label: '轮播广告', name: '/carousel' },
        { label: '贴纸广告', name: '/sticker' }
      ]
    }
  }
}
</script>